import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import styles from "./index.module.scss";
import componentStyles from "../index.module.scss";
import { loginStore } from "@/modules/login/store";
import { postAddAlbum, postImageAlbum, postMoveAlbum, postRemoveAlbum } from "@/modules/album/api";
import { parseLabels } from "@/utils/misc";
import JoinedAlbum, { AlbumsItemType } from "@/pages/Gallery/components/Album/JoinedAlbum";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";

export interface AlbumData {
  image_id: number;
  album_id: number;
  album_image_id: number;
  album_name: string;
  meta_json: string;
  is_album?: boolean;
  image_url: string;
}
interface AlbumProps {
  is_gallery?: boolean;
  albumData?: AlbumData;
  onAlbum?: (type: 1 | 2 | 3, albumData: AlbumData) => void;
  onError?: (e: any) => void;
}
const Index: FC<AlbumProps> = (props) => {
  const { is_gallery, albumData, onAlbum, onError } = props;
  const { translate } = useTranslate();
  const addAlbumEvents = async () => {
    try {
      await postAddAlbum([
        {
          image_id: Number(albumData?.image_id),
          meta_json: albumData?.meta_json as string,
          image_url: albumData?.image_url as string,
          source: "finished",
          is_ai: parseLabels(JSON.parse(albumData?.meta_json as string))?.isAI ? 1 : 2,
        },
      ]);

      const {
        data: { albums },
      } = await postImageAlbum({
        type: "finished",
        image_id: Number(albumData?.image_id),
      });
      onAlbum?.(1, {
        ...(albumData as AlbumData),
        album_id: albums[0]?.id,
        album_name: albums[0]?.name,
        album_image_id: albums[0]?.album_image_id,
      });
    } catch (e) {
      onError?.(e);
    }
  };
  const handleAddAlbum = async () => {
    if (!loginStore.isLogin) {
      loginStore.openLoginDialog({}, () => {
        addAlbumEvents();
      });
    } else {
      await addAlbumEvents();
    }
  };
  const onRemoveAlbum = async () => {
    try {
      await postRemoveAlbum({
        album_id: albumData?.album_id as number,
        album_image_ids: [albumData?.album_image_id as number],
      });
      onAlbum?.(3, albumData as AlbumData);
    } catch (e) {
      onError?.(e);
    }
  };
  const onMoveAlbum = async (toAlbumData: AlbumsItemType) => {
    try {
      await postMoveAlbum({
        album_id: albumData?.album_id as number,
        to_album_id: toAlbumData.id,
        album_image_ids: [albumData?.album_image_id as number],
      });
      onAlbum?.(2, {
        ...(albumData as AlbumData),
        album_id: toAlbumData.id,
        album_name: toAlbumData.name,
      });
    } catch (e) {
      onError?.(e);
    }
  };
  return (
    <div
      className={is_gallery ? componentStyles.albumGalleryWrapper : styles.albumWrapper}
      style={{ justifyContent: albumData?.is_album ? "center" : "flex-end" }}
    >
      {!albumData?.is_album ? (
        <button
          className={styles.addAlbum}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            await handleAddAlbum();
          }}
        >
          {translate(AlbumWords.addToAlbum)}
        </button>
      ) : (
        <JoinedAlbum
          isGallery={is_gallery}
          albumData={albumData}
          onMoveAlbum={onMoveAlbum}
          onRemoveAlbum={onRemoveAlbum}
        />
      )}
    </div>
  );
};
export default observer(Index);
